module.exports = __webpack_public_path__ + "public/files/img/lessons.8e04989b.gif";